// components/FilterRow.jsx
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDCircularProgress from "components/MDCircularProgress";
import MDDateRangePicker from "components/MDDateRangePicker";
import MDInput from "components/MDInput";
import MDMultipleSelect from "components/MDMultipleSelect";
import MDSelect from "components/MDSelect";
import MDTypography from "components/MDTypography";
import { Link } from "react-router-dom";

const FilterRow = ({
  filterData,
  setFilterData,
  wlIdsOptions,
  categoryOptions,
  genderOptions,
  listSearchHandler,
  maxError,
  setMaxError,
  dateRange,
  setDateRange,
  keyProp,
  filterLoading,
  renderAlertSB,
}) => {
  return {
    listing_type: (
      <MDSelect
        label=""
        fullWidth
        value={filterData?.listing_type || ""}
        onChange={(e) =>
          setFilterData({ ...filterData, listing_type: e.target.value })
        }
        options={wlIdsOptions}
      />
    ),

    listing_id: (
      <MDInput
        type="text"
        label=""
        fullWidth
        value={filterData?.listing_id || ""}
        sx={{ width: "90px" }}
        inputProps={{ maxLength: 10 }}
        onChange={(e) =>
          setFilterData({ ...filterData, listing_id: e.target.value })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") listSearchHandler(e, false);
        }}
      />
    ),

    title: (
      <MDInput
        type="text"
        label=""
        fullWidth
        value={filterData?.title || ""}
        name="title"
        sx={{ width: "100%" }}
        inputProps={{ maxLength: 100 }}
        onChange={(e) =>
          setFilterData({ ...filterData, title: e.target.value })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") listSearchHandler(e, false);
        }}
      />
    ),

    price: (
      <MDBox
        display="flex"
        alignItems="center"
        border={maxError ? "1px solid #ff0000" : "1px solid #ccc"}
        borderRadius="8px"
        overflow="hidden"
        height="40px"
        width="110px"
      >
        <MDInput
          type="number"
          placeholder="Min"
          value={filterData?.min_price || ""}
          inputProps={{ min: 0 }}
          onChange={(e) =>
            setFilterData({ ...filterData, min_price: e.target.value })
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") listSearchHandler(e, false);
          }}
          sx={numberInputStyle}
        />
        <MDBox px={1} sx={{ userSelect: "none" }}>
          -
        </MDBox>
        <MDInput
          type="number"
          placeholder="Max"
          value={filterData?.max_price || ""}
          inputProps={{ min: 0 }}
          onChange={(e) =>
            setFilterData({ ...filterData, max_price: e.target.value })
          }
          onBlur={(e) => {
            const maxValue = Number(e.target.value);
            const minValue = Number(filterData?.min_price || 0);
            setMaxError(!isNaN(maxValue) && maxValue < minValue);
          }}
          onKeyDown={(e) => {
            const maxValue = Number(e.target.value);
            const minValue = Number(filterData?.min_price || 0);
            const isError = !isNaN(maxValue) && maxValue < minValue;
            if (e.key === "Enter") {
              if (!isError) listSearchHandler(e, false);
              else setMaxError(true);
            } else {
              setMaxError(false);
            }
          }}
          sx={numberInputStyle}
        />
      </MDBox>
    ),

    avg_price: (
      <MDBox
        display="flex"
        alignItems="center"
        border="1px solid #ccc"
        borderRadius="8px"
        overflow="hidden"
        height="40px"
        width="110px"
      >
        <MDInput
          type="number"
          placeholder="Min"
          value={filterData?.min_avg_price || ""}
          inputProps={{ min: 0 }}
          onChange={(e) =>
            setFilterData({ ...filterData, min_avg_price: e.target.value })
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") listSearchHandler(e, false);
          }}
          sx={numberInputStyle}
        />
        <MDBox px={1} sx={{ userSelect: "none" }}>
          -
        </MDBox>
        <MDInput
          type="number"
          placeholder="Max"
          value={filterData?.max_avg_price || ""}
          inputProps={{ min: 0 }}
          onChange={(e) =>
            setFilterData({ ...filterData, max_avg_price: e.target.value })
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") listSearchHandler(e, false);
          }}
          sx={numberInputStyle}
        />
      </MDBox>
    ),

    category: (
      <MDMultipleSelect
        label=""
        fullWidth
        value={filterData?.category || []}
        onChange={(e) => handleAllSelectChange(e, "category", categoryOptions, filterData, setFilterData)}
        options={categoryOptions}
        sx={{ flex: 1, width: 110 }}
      />
    ),

    gender: (
      <MDMultipleSelect
        label=""
        fullWidth
        value={filterData?.gender || []}
        onChange={(e) => handleAllSelectChange(e, "gender", genderOptions, filterData, setFilterData)}
        options={genderOptions}
        sx={{ flex: 1, width: 110 }}
      />
    ),

    reserve_status: (
      <MDInput
        type="text"
        label=""
        fullWidth
        value={filterData?.reserve_status || ""}
        name="reserve_status"
        inputProps={{ maxLength: 100 }}
        onChange={(e) =>
          setFilterData({ ...filterData, reserve_status: e.target.value })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") listSearchHandler(e, false);
        }}
      />
    ),

    end_date: (
      <MDDateRangePicker
        key={keyProp}
        value={dateRange}
        onChange={(val) => {
          setDateRange(val);
          setFilterData({
            ...filterData,
            start_date: val.startDate,
            end_date: val.endDate,
          });
        }}
        placeholder="Select Range"
        width="200px"
      />
    ),

    action: (
      <MDBox display="flex">
        <MDTypography
          mr={1}
          component={Link}
          onClick={(e) => listSearchHandler(e, false)}
          title="Search"
          display="block"
          variant="caption"
          color="success"
          fontWeight="medium"
        >
          {filterLoading?.search_loading ? (
            <MDCircularProgress color="info" size={20} />
          ) : (
            <Icon fontSize="medium" sx={{ fontWeight: "bold" }}>
              search_icon
            </Icon>
          )}
        </MDTypography>
        <MDTypography
          component={Link}
          onClick={(e) => listSearchHandler(e, true)}
          title="Clear"
          display="block"
          variant="caption"
          color="primary"
          fontWeight="medium"
        >
          {filterLoading?.clear_loading ? (
            <MDCircularProgress color="info" size={20} />
          ) : (
            <Icon fontSize="medium" sx={{ fontWeight: "bold" }}>
              clear_icon
            </Icon>
          )}
        </MDTypography>
        {renderAlertSB}
      </MDBox>
    ),
  };
};

export default FilterRow;

const numberInputStyle = {
  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
  "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
  "& input": {
    padding: "10px",
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    "&[type=number]": { MozAppearance: "textfield" },
  },
};

function handleAllSelectChange(e, field, options, filterData, setFilterData) {
  const oldValues = filterData?.[field] || [];
  const selectedValues = e.target.value;
  const allOptions = options.map((option) => option.key);

  if (!oldValues.includes("All") && selectedValues.includes("All")) {
    setFilterData({ ...filterData, [field]: allOptions });
  } else if (oldValues.includes("All") && !selectedValues.includes("All")) {
    setFilterData({ ...filterData, [field]: [] });
  } else if (
    selectedValues.includes("All") &&
    selectedValues.length === allOptions.length - 1
  ) {
    setFilterData({
      ...filterData,
      [field]: selectedValues.filter((v) => v !== "All"),
    });
  } else if (
    !selectedValues.includes("All") &&
    selectedValues.length === allOptions.length - 1
  ) {
    setFilterData({ ...filterData, [field]: [...selectedValues, "All"] });
  } else {
    setFilterData({ ...filterData, [field]: selectedValues });
  }
}
